import React, { PureComponent, Fragment } from "react";

import {
  PieChart,
  Pie,
  BarChart,
  Bar,
  Tooltip,
  Cell,
  ResponsiveContainer,
  YAxis,
  XAxis,
  CartesianGrid
} from "recharts";

import {
  StandardTooltip,
  CustomizedXAxisTick,
  selectFormat
} from "./../../Utils/Utils.js";

import maleFemaleIcon from "./../../../i/nbc/male_female.jpg";

const renderName = name => name;
const order = ["females", "unknown", "males"];
const COLORS = {
  males: "#14c8de",
  females: "#fa7986",
  unknown: "#ccc"
};

export class DemographicsPieChart extends PureComponent {
  constructor(props) {
    super(props);
    this.renderCell = this.renderCell.bind(this);
  }

  renderCell = (entry, index) => {
    return <Cell key={index} fill={COLORS[entry.name]} />;
  };

  renderPercentage() {
    const { data } = this.props;
    const total = data.graph.reduce((s, e) => s + e.value, 0);
    const sorted = data.graph.slice().sort((a, b) => b.value - a.value);

    return sorted.map((e, key) => {
      if (((e.value * 100) / total).toFixed(0) > 0) {
        // prevent 0%
        return (
          <div className="col-6 text-left mb-1" key={e.name}>
            <span className="pr-1" style={{ color: COLORS[e.name] }}>
              {((e.value * 100) / total).toFixed(0)}%
            </span>
            <span>{renderName(e.name)}</span>
          </div>
        );
      } else {
        return null;
      }
    });
  }

  render() {
    const { data } = this.props;
    const total = data.graph.reduce((s, e) => s + e.value, 0);
    data.graph.slice().sort((a, b) => a.value - b.value); //data.graph.sort((a, b) => order.indexOf(b.value) - order.indexOf(a.value))
    data.graph = order.map(name => {
      return data.graph.filter(d => d.name === name)[0];
    });

    return (
      <Fragment>
        <div className="row mb-3 pt-3 pt-lg-0">
          <ResponsiveContainer height={120} width={120}>
            <PieChart>
              <Pie
                data={data.graph}
                dataKey="value"
                innerRadius={30}
                outerRadius={60}
                startAngle={90}
                endAngle={-270}
              >
                {data.graph.map(this.renderCell)}
              </Pie>
              <image
                x="45"
                y="40"
                width="30"
                height="40"
                xlinkHref={maleFemaleIcon}
              />

              <Tooltip
                cursor={{ fill: "#eee", opacity: 0.5 }}
                content={
                  <StandardTooltip
                    total={total}
                    render={({ data }) => {
                      const payload = data(data.graph);

                      if (payload !== null) {
                        return (
                          <div className="standard-tooltip">
                            <header className="standard-tooltip__header">
                              <span className="standard-tooltip__key-header">
                                Demographics
                              </span>
                            </header>

                            <main className="standard-tooltip__main">
                              {Object.keys(payload)
                                .sort(
                                  (a, b) => payload[a].value - payload[b].value
                                )
                                .filter(key => payload[key].value > 0)
                                .map(key => {
                                  const totalPercentage = ((payload[key].payload.value * 100) / total);
                                  return (
                                    <Fragment key={key}>
                                      <div
                                        className="standard-tooltip__item"
                                        key={"item1"}
                                      >
                                        <span
                                          className="standard-tooltip__key"
                                          style={{ color: payload[key].color }}
                                        >
                                          <span
                                            className="standard-tooltip__icon"
                                            style={{
                                              background:
                                                payload[key].payload.fill
                                            }}
                                          ></span>
                                          {renderName(payload[key].payload.name)}
                                        </span>
                                        <span className="standard-tooltip__value">
                                          {totalPercentage.toFixed(0)}
                                          % { totalPercentage !== payload[key].payload.value && ("(" + selectFormat("number", payload[key].payload.value, "0.0a") + ")") }
                                        </span>
                                      </div>
                                    </Fragment>
                                  )

                                  }
                                )
                              }
                            </main>
                          </div>
                        );
                      }
                    }}
                  />
                }
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="row justify-content-left">
          {this.renderPercentage()}
        </div>
      </Fragment>
    );
  }
}

export class DemographicsBarChart extends PureComponent {
  render() {
    const { data } = this.props;
    const total = data.graph.reduce((s, e) => s + e.value, 0);

    return (
      <ResponsiveContainer height={158}>
        <BarChart
          data={data.graph}
          layout="vertical"
          margin={{ top: 0, right: 20, left: 0, bottom: 0 }}
        >
          <Tooltip
            cursor={{ fill: "#eee", opacity: 0.5 }}
            content={
              <StandardTooltip
                total={total}
                render={({ data }) => {
                  const payload = data(this.props);
                  if (payload !== null) {
                    return (
                      <div className="standard-tooltip">
                        {Object.keys(payload).map(key => {
                          const totalPercentage = ((payload[key].payload.value * 100) / total).toFixed(0);
                          return (
                            <Fragment key={key}>
                              <header className="standard-tooltip__header">
                                <span className="standard-tooltip__key-header">
                                  Demographics
                                </span>
                              </header>
                              <main className="standard-tooltip__main">
                                <div className="standard-tooltip__item">
                                  <span className="standard-tooltip__key">
                                    <span
                                      className="standard-tooltip__icon"
                                      style={{ background: "#FA6E57" }}
                                    ></span>
                                    <span className="standard-tooltip__value-header">
                                      {payload[key].payload.name}
                                    </span>
                                  </span>
                                  <span className="standard-tooltip__value">
                                    {totalPercentage}
                                    % { totalPercentage !== payload[key].payload.value.toString() && ("(" + selectFormat("number", payload[key].payload.value, "0.0a") + ")") }
                                  </span>
                                </div>
                              </main>
                            </Fragment>
                          )
                        })}
                      </div>
                    );
                  }
                }}
              />
            }
          />
          <XAxis
            type="number"
            axisLine={false}
            tickLine={false}
            mirror={false}
            dataKey="value"
            tick={<CustomizedXAxisTick />}
          />
          <YAxis
            type="category"
            axisLine={false}
            tickLine={false}
            mirror={false}
            dataKey="name"
            interval={0}
          />
          <CartesianGrid
            strokeDasharray="3 3"
            horizontal={false}
            stroke={"#FC6D52"}
            strokeOpacity={0.3}
          />

          <defs>
            <linearGradient
              id="colorDemographicBar"
              x1="0"
              y1="0"
              x2="1"
              y2="0"
            >
              <stop offset="5%" stopColor="#FAA461" stopOpacity={1} />
              <stop offset="95%" stopColor="#FC6D52" stopOpacity={1} />
            </linearGradient>
          </defs>

          <Bar dataKey="value" fill="url(#colorDemographicBar)" />
        </BarChart>
      </ResponsiveContainer>
    );
  }
}
